'use client';

import { ProfileEditForm } from '@eliadmin/core/src/components/profile/profile-edit-form';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { Heading } from '../../../components/ui/heading';

export default function Page() {
  const { t } = useTranslations();

  return (
    <section>
      <Heading
        title={t('text491')}
        tag="h1"
        className={{ container: 'items-center justify-center text-center' }}
      />
      <ProfileEditForm />
    </section>
  );
}
